export const SOURCE_TYPE_FETCH_IN_PROGRESS = 'SOURCE_TYPE_FETCH_IN_PROGRESS';
export const SOURCE_TYPE_FETCH_SUCCESS = 'SOURCE_TYPE_FETCH_SUCCESS';
export const SOURCE_TYPE_FETCH_ERROR = 'SOURCE_TYPE_FETCH_ERROR';
